<template>
  <input :disabled="disabled" :name="name || label" class="fct-input" :id="id || 'input-' + label" :type="type"
         :value="presentedValue"
         @input="onInput" @blur="onBlur">
</template>

<script>
  export default {
    props: {
      id: String,
      label: String,
      name: String,
      value: {type: String, default: ''},
      disabled: Boolean,
      type: String,
      prefix: {type: String, default: ''},
      suffix: {type: String, default: ''}
    },
    methods: {
      onInput({target}) {
        let {value: newVal} = target;

        const newValOK = newVal.startsWith(this.prefix) && newVal.endsWith(this.suffix);
        if (newValOK)
          this.$emit('input', newVal.slice(this.prefix.length, -this.suffix.length || undefined));
        else
          target.value = this.presentedValue;

      },
      onBlur(e) {
        e.target.value = e.target.value.trim()
      }
    },
    computed:{
      presentedValue() { return this.prefix + this.value + this.suffix; }
    }
  };
</script>

<style scoped>

</style>
